import createReactComponent from '../createReactComponent';
export default createReactComponent('chevrons-down', 'IconChevronsDown', [
  ['path', { d: 'M7 7l5 5l5 -5', key: 'svg-0' }],
  ['path', { d: 'M7 13l5 5l5 -5', key: 'svg-1' }],
]);
